import React from "react"

const Card = props => (
  <div className="card" style={{marginBottom: '1.5rem'}}>
    <div className="card-body mb-6">
      <h4 className="card-title mb-4"><a href={props.titleLink}>{props.sectionTitle}</a></h4>
      <h6 className="card-subtitle mb-4 text-muted">{props.sectionSubtitle}</h6>
      {props.children}
    </div>
  </div>
)

export default Card
